var hasProp = window.hasProp;
var extend = window.extend;
var extend = function (child, parent) {
    for (var key in parent) {
      if (hasProp.call(parent, key)) child[key] = parent[key];
    }
    function ctor() {
      this.constructor = child;
    }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
    child.__super__ = parent.prototype;
    return child;
  },
  hasProp = {}.hasOwnProperty;
window.app = window.app || {};
app.models = app.models || {};
app.views = app.views || {};
app.config = app.config || {};
app.config.max_file_size = 104857600;
app.config.max_file_name_length = 125;
app.config.accepted_file_types = ['pdf', 'txt', 'ps', 'rtf', 'epub', 'odt', 'odp', 'ods', 'odg', 'odf', 'sxw', 'sxc', 'sxi', 'sxd', 'doc', 'ppt', 'pps', 'xls', 'docx', 'pptx', 'ppsx', 'xlsx', 'csv', 'tsv'];
app.views.Uploader_v2 = function (superClass) {
  extend(Uploader_v2, superClass);
  function Uploader_v2() {
    return Uploader_v2.__super__.constructor.apply(this, arguments);
  }
  Uploader_v2.prototype.initialize = function (options) {
    this.max_file_size = options.max_file_size || app.config.max_file_size;
    this.max_file_name_length = options.max_file_name_length || app.config.max_file_name_length;
    this.accepted_file_types = options.accepted_file_types || app.config.accepted_file_types;
    this.notifier = options.event_recorder;
    return req("jquery.fileupload", function (_this) {
      return function () {
        return options.input.fileupload({
          url: options.url || _this._attachment_url(options.work_id, options.source),
          dataType: "json",
          dropZone: options.dropZone,
          add: function (e, data) {
            var uploading_file, validation_errors;
            uploading_file = data.files[0];
            validation_errors = _this._validate_file(uploading_file);
            if (validation_errors) {
              _this.trigger("error", validation_errors, uploading_file);
              return;
            }
            data.submit();
            _this._record_event('upload_started');
            return _this.trigger("add", uploading_file);
          },
          progress: function (e, data) {
            var ref, uploading_file;
            uploading_file = data.files[0];
            if ((ref = uploading_file.model) != null) {
              ref.trigger("progress", data.progress());
            }
            return _this.trigger("progress", data.progress());
          },
          done: function (e, data) {
            var ref, uploading_file;
            uploading_file = data.files[0];
            if ((ref = uploading_file.model) != null) {
              ref.trigger("done", data);
            }
            return _this.trigger("done", data);
          },
          fail: function (e, data) {
            var ref, uploading_file;
            uploading_file = data.files[0];
            if ((ref = uploading_file.model) != null) {
              ref.trigger("fail", data);
            }
            _this.trigger("fail", data);
            return _this._record_event('upload_failed', $a.fileUploadErrorString(data), 'v2_uploader');
          }
        });
      };
    }(this));
  };
  Uploader_v2.prototype._validate_file = function (file) {
    var errors;
    errors = _.compact([this._validate_file_size(file), this._validate_file_type(file), this._validate_file_name_length(file)]);
    if (errors.length !== 0) {
      return errors;
    }
  };
  Uploader_v2.prototype._validate_file_size = function (file) {
    if (file.size > this.max_file_size) {
      return {
        "file_size": file.size
      };
    }
  };
  Uploader_v2.prototype._validate_file_name_length = function (file) {
    if (file.name.length > this.max_file_name_length) {
      return {
        "file_name_length": file.name.length
      };
    }
  };
  Uploader_v2.prototype._validate_file_type = function (file) {
    var extension;
    extension = _.last(file.name.split(/\./)).toLowerCase();
    if (!_.include(this.accepted_file_types, extension)) {
      return {
        "file_type": extension
      };
    }
  };
  Uploader_v2.prototype._attachment_url = function (work_id, source) {
    var params;
    params = {
      work_id: work_id,
      subdomain_param: 'api'
    };
    if (source) {
      params.source = source;
    }
    return $r.api_v0_attachments_path(params);
  };
  Uploader_v2.prototype._record_event = function (event_name, error, source) {
    if (typeof $a !== "undefined" && $a !== null ? $a.log : void 0) {
      $a.log(event_name);
    }
    if (this.notifier != null) {
      return this.notifier.notify({
        event: event_name,
        user_id: $current_user.id,
        source: source || this.options.source,
        error: error,
        user_time: parseInt(new Date().getTime() / 1000)
      });
    }
  };
  return Uploader_v2;
}(Backbone.View);
window.extend = extend;
window.hasProp = hasProp;